module.exports = __webpack_public_path__ + "static/media/phaneroptera_falcata_006_APA.dd084cfe.mp3";